var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.localizedTabs, function(tabItem, index) {
            return _c("v-tab", { key: index }, [
              _c("span", { staticClass: "tabItem" }, [
                _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
              ])
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mt-2" },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "", "justify-space-between": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "", "ml-2": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "" } },
                        [
                          _c("v-flex", [_vm._v(_vm._s(_vm.$t("fontSize")))]),
                          _vm._v(" "),
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.orderNumberFontSize,
                                callback: function($$v) {
                                  _vm.orderNumberFontSize = $$v
                                },
                                expression: "orderNumberFontSize"
                              }
                            },
                            _vm._l(3, function(n) {
                              return _c("v-radio", {
                                key: n,
                                attrs: {
                                  label: "" + _vm.radioLabel[n - 1],
                                  value: n
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { md6: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "" } },
                        [
                          _c("v-flex"),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md2: "" } }, [
                            _vm._v(_vm._s(_vm.$t("printMode")))
                          ]),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            attrs: {
                              disabled: _vm.connectFailed,
                              label: _vm.$t("autoPrint")
                            },
                            model: {
                              value: _vm.autoPrint,
                              callback: function($$v) {
                                _vm.autoPrint = $$v
                              },
                              expression: "autoPrint"
                            }
                          }),
                          _vm._v(" "),
                          _vm.connectFailed
                            ? _c(
                                "v-flex",
                                { attrs: { md2: "" } },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          color: "black"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openLink(
                                                              "https://qz.io/download/"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      "\n                    help_outline\n                    small\n                  "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1627790385
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("autoPrintHelp")))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.autoPrint
                            ? _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.printers,
                                      label: _vm.$t("selectPrinter")
                                    },
                                    model: {
                                      value: _vm.selectPrinter,
                                      callback: function($$v) {
                                        _vm.selectPrinter = $$v
                                      },
                                      expression: "selectPrinter"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _vm.loading
                                ? _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.tab === 0
        ? _c(
            "v-card",
            { staticClass: "mt-2" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-start": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { md2: "", "ml-2": "" } },
                        [
                          _c("v-checkbox", {
                            attrs: { label: _vm.$t("secondaryMatching") },
                            model: {
                              value: _vm.isSecondaryMatching,
                              callback: function($$v) {
                                _vm.isSecondaryMatching = $$v
                              },
                              expression: "isSecondaryMatching"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isSecondaryMatching
                        ? _c(
                            "v-flex",
                            { attrs: { md4: "", "ml-2": "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: _vm.$t("suffix") },
                                model: {
                                  value: _vm.secondaryMatchingText,
                                  callback: function($$v) {
                                    _vm.secondaryMatchingText =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "secondaryMatchingText"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          attrs: { touchless: "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "v-tab-item",
            { key: index },
            [
              index == 0
                ? [
                    _c(
                      "v-layout",
                      {
                        staticStyle: { "margin-top": "30px" },
                        attrs: { column: "", "justify-center": "" }
                      },
                      [
                        _c(
                          "v-flex",
                          { staticClass: "text-center", attrs: { xs12: "" } },
                          [
                            _c("h2", [
                              _vm._v(_vm._s(_vm.$t("uploadOrderPrint")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { "align-center": "", row: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.downloadTemplate(
                                      "label-print.xlsx"
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("template")) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { staticClass: "text-left" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "primary",
                                      title: "importFile",
                                      loading: _vm.uploading
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: { dark: "", left: "", small: "" }
                                      },
                                      [_vm._v("cloud_upload")]
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("upload")) +
                                        "\n                "
                                    ),
                                    _c("input", {
                                      staticClass: "hideInput",
                                      attrs: {
                                        type: "file",
                                        accept: ".csv,.xls,.xlsx"
                                      },
                                      on: {
                                        click: _vm.clearSelectionCache,
                                        change: _vm.uploadFile
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.fileName) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-divider", { staticClass: "flex xs12 sm12 mt-3" }),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { staticClass: "my-3", attrs: { column: "" } },
                      [
                        _c(
                          "v-flex",
                          { staticClass: "text-center", attrs: { xs12: "" } },
                          [
                            _c("h2", [
                              _vm._v(_vm._s(_vm.$t("scanLabelPrinter")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              "align-center": "",
                              "justify-space-between": ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md8: "", xs8: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-center": "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          color: "primary",
                                          small: ""
                                        },
                                        on: { click: _vm.selectFile }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              dark: "",
                                              left: "",
                                              small: ""
                                            }
                                          },
                                          [_vm._v("folder_open")]
                                        ),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("selectDirectory")) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      ref: "barcodeInput",
                                      refInFor: true,
                                      staticClass: "ml-4",
                                      attrs: {
                                        label: _vm.files.length
                                          ? _vm.$t("inputBarcodeHere", {
                                              forceMode: ""
                                            })
                                          : _vm.$t("selectDirectoryFirst"),
                                        autofocus: ""
                                      },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.addBarcode.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.barcode,
                                        callback: function($$v) {
                                          _vm.barcode = $$v
                                        },
                                        expression: "barcode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { md2: "" } },
                              [
                                _vm.autoPrint
                                  ? _c("v-text-field", {
                                      attrs: { label: _vm.$t("printQuantity") },
                                      model: {
                                        value: _vm.printQuantity,
                                        callback: function($$v) {
                                          _vm.printQuantity = $$v
                                        },
                                        expression: "printQuantity"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.directoryName
                          ? _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "text-xs-left",
                                    attrs: { xs12: "", "ml-2": "" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("selectDirectoryName"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-1" }, [
                                      _vm._v(_vm._s("/" + _vm.directoryName))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs12: "" } }, [
                          _vm.currentFile
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    height: "500px"
                                  }
                                },
                                [
                                  _c("iframe", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: {
                                      src: _vm.currentFile.base64,
                                      frameborder: "0"
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              index == 1
                ? [
                    _c(
                      "v-layout",
                      { staticClass: "my-3", attrs: { column: "" } },
                      [
                        _c(
                          "v-flex",
                          { staticClass: "text-center", attrs: { md3: "" } },
                          [_c("h2", [_vm._v(_vm._s(_vm.$t("convertBarcode")))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              "align-center": "",
                              "justify-space-between": ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-center": "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { small: "", color: "primary" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.downloadTemplate(
                                              "convert-barcode.xlsx"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("template")) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "primary",
                                              title: "importFile"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  dark: "",
                                                  left: "",
                                                  small: ""
                                                }
                                              },
                                              [_vm._v("cloud_upload")]
                                            ),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("upload")) +
                                                "\n                  "
                                            ),
                                            _c("input", {
                                              staticClass: "hideInput",
                                              attrs: {
                                                type: "file",
                                                accept: ".csv,.xls,.xlsx"
                                              },
                                              on: {
                                                click: _vm.clearSelectionCache,
                                                change:
                                                  _vm.uploadFileForConvertBarcode
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      ref: "convertBarcodeInput",
                                      refInFor: true,
                                      staticClass: "ml-4",
                                      attrs: {
                                        label: _vm.uploadFileName
                                          ? _vm.$t("inputBarcodeHere", {
                                              forceMode: ""
                                            })
                                          : _vm.$t("selectFileFirst"),
                                        autofocus: ""
                                      },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.addBarcode.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.barcode,
                                        callback: function($$v) {
                                          _vm.barcode = $$v
                                        },
                                        expression: "barcode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uploadFileName
                          ? _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass: "text-xs-left",
                                    attrs: { xs12: "", "ml-2": "" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("fileName") + ":"))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-1" }, [
                                      _vm._v(_vm._s(_vm.uploadFileName))
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.beforeConvertFile && _vm.currentConvertFile
                          ? _c(
                              "v-layout",
                              {
                                attrs: {
                                  "justify-center": "",
                                  "align-center": ""
                                }
                              },
                              [
                                _c("v-flex", { attrs: { xs12: "" } }, [
                                  _vm.beforeConvertFile
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            height: "378px",
                                            width: "578px"
                                          }
                                        },
                                        [
                                          _c("iframe", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              transform: "scale(0.8)"
                                            },
                                            attrs: {
                                              src: _vm.beforeConvertFile.base64,
                                              frameborder: "0"
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-icon",
                                      { staticStyle: { "font-size": "140px" } },
                                      [_vm._v("arrow_right")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-flex", { attrs: { xs12: "" } }, [
                                  _vm.currentConvertFile
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            height: "378px",
                                            width: "578px"
                                          }
                                        },
                                        [
                                          _c("iframe", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              transform: "scale(0.8)"
                                            },
                                            attrs: {
                                              src:
                                                _vm.currentConvertFile.base64,
                                              frameborder: "0"
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79ef9e6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79ef9e6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelMapping.vue
// module id = null
// module chunks = 